import { useState, useEffect } from 'react';
import logger from 'ws-scripts/modules/logger';
import useEventBus from './useEventBus';
import {
	addTotalTimeToNewRelic,
	startTimeMarker,
	endTimeMarker,
	getPerformanceMeasure
} from '../helpers/logging-client';

const useIncentivesData = (incentiveIds) => {
	const [incentivesData, setIncentivesData] = useState([]);
	const [eventBus, isReady] = useEventBus();
	const [isLoadingIncentives, setIsLoadingIncentives] = useState(
		!!incentiveIds.length
	);

	useEffect(() => {
		if (isReady && incentiveIds.length) {
			setIsLoadingIncentives(true);

			const handleIncentivesCompleted = (incentiveData) => {
				endTimeMarker('incentives');
				const elapsedTime = getPerformanceMeasure('incentives');

				logger.info(
					'WS-TRACK-MY-OFFER -> uds:incentives:completed:',
					incentiveData
				);

				setIncentivesData(incentiveData);
				setIsLoadingIncentives(false);

				addTotalTimeToNewRelic(elapsedTime, 'incentives');
			};

			eventBus.on(
				'uds:getIncentives:completed',
				handleIncentivesCompleted
			);

			// Emit event to get incentives
			// TODO: see if there is a way to refactor
			// to avoid using timeout here
			// talk to syndication about adding a param for dealType
			setTimeout(() => {
				startTimeMarker('incentives');
				eventBus.emit('uds:getIncentives:request');
			}, 50);

			return () => {
				eventBus.off(
					'uds:getIncentives:completed',
					handleIncentivesCompleted
				);
			};
		}

		return () => {};
	}, [isReady, incentiveIds, eventBus]);

	return [incentivesData, isLoadingIncentives];
};

export default useIncentivesData;
